/**
 * 平台内置模型供应商 type / strategyProvider 约定值。
 * L2 headless 与页面共用；禁止从 `@/pages` 回引。
 */
export const INTERNAL_MODEL_TYPE = 'platform-built-in';

/** 模型订阅计价：厂商设备查询资源 code（父资源） */
export const MS_PROVIDER_TOKEN_RESOURCE_CODE = 'Token';

/** Token 配额数量单位（计价模式展示用） */
export const MS_PROVIDER_TOKEN_UNIT = 'MillionToken';

/** 子资源计价：输入 Token code（与原子资源 subResourceSpecInfos / 询价约定对齐） */
export const MS_SUB_RESOURCE_INPUT_TOKEN_CODE = 'InputToken';

/** 子资源计价：输出 Token code */
export const MS_SUB_RESOURCE_OUTPUT_TOKEN_CODE = 'OutputToken';

/** 计价厂商设备元数据字段前缀（与表单扁平字段 providerPricing 对齐） */
export const MS_PROVIDER_PRICING_FIELD = 'providerPricing';

/** 触发询价时需监听的厂商设备元数据字段 */
export const MS_PROVIDER_PRICING_WATCH_FIELDS = [
  MS_PROVIDER_PRICING_FIELD,
  `${MS_PROVIDER_PRICING_FIELD}.vendor`,
  `${MS_PROVIDER_PRICING_FIELD}.vendorID`,
  `${MS_PROVIDER_PRICING_FIELD}.device`,
  `${MS_PROVIDER_PRICING_FIELD}.deviceID`,
  `${MS_PROVIDER_PRICING_FIELD}.deviceType`,
  `${MS_PROVIDER_PRICING_FIELD}.billItemId`,
] as const;
